import styled from "styled-components/macro";

export default styled.ul(({ styleType }) => ({
  listStyleType: styleType,
  marginInlineStart: styleType !== "none" ? "32px" : "0px",
}));
